export const isCustomizedKitProduct = (
  productComponents,
  isInstantAccessUser?: boolean,
  isLoggedIn?: boolean,
  isPackage?: boolean,
  isCustomizable?: boolean,
  isBundle?: boolean,
  isGuestUser?: boolean,
  catcorp?: boolean
) => {
  const isPackageWithItemAssociated =
    (productComponents && productComponents?.length > 0) ?? false;

  return (
    ((isInstantAccessUser && isLoggedIn) || isGuestUser) &&
    !catcorp &&
    isPackageWithItemAssociated &&
    ((isPackage && isCustomizable) || isBundle)
  );
};
